import { render, staticRenderFns } from "./FunnelsSessionList.vue?vue&type=template&id=5228edce&scoped=true"
import script from "./FunnelsSessionList.vue?vue&type=script&lang=js"
export * from "./FunnelsSessionList.vue?vue&type=script&lang=js"
import style0 from "./FunnelsSessionList.vue?vue&type=style&index=0&id=5228edce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228edce",
  null
  
)

export default component.exports